import { useState, useEffect } from 'react';

import { getAbTestV2, trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2.ts';

import { PDP_SELLER_BRANDING_V2_JULY_2026 } from '../../constants/abTestsConstants.ts';

const isSellerBrandingV2Variant = (): boolean =>
    getAbTestV2(PDP_SELLER_BRANDING_V2_JULY_2026)?.variant === 'variant1';

const trackSellerBrandingV2Test = (): void => {
    trackAbTestV2Variant(PDP_SELLER_BRANDING_V2_JULY_2026);
};

export const useIsSellerBrandingV2Variant = (): boolean => {
    const [isVariant, setIsVariant] = useState(false);

    useEffect(() => {
        setIsVariant(isSellerBrandingV2Variant());
    }, []);

    return isVariant;
};

export const useTrackSellerBrandingV2Test = (): void => {
    useEffect(() => {
        trackSellerBrandingV2Test();
    }, []);
};
